import { render, staticRenderFns } from "./shop-request-checkin-history.vue?vue&type=template&id=f2b9cdae"
import script from "./shop-request-checkin-history.vue?vue&type=script&lang=js"
export * from "./shop-request-checkin-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports